<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">期间</label>
            <span class="weui-form-preview__value">{{initData.cm_yearmonth}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户</label>
            <span class="weui-form-preview__value">{{initData.cu_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">期初余额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_begin_gs}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本期增加</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_add_gs}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本期减少</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_reduce_gs}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">期末金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_end_gs}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>